<template>
	<div>
		<FiltersListSection
			:clip-filters="playerFilters"
			:title="title"
			:value="selectedPlayerFilters"
			@input="handleSelectPlayers"
		>
			<template #subheader>
				<div class="subheader">
					<Checkbox
						:id="`whole-team-${team.id}`"
						:value="isTeamSelected"
						:label="transUcfirst('commons.select_team')"
						:disabled="!canSelectTeam"
						@input="handleSelectTeam"
					/>
				</div>
			</template>
		</FiltersListSection>
	</div>
</template>

<script>
import FiltersListSection from './FiltersListSection';
import Checkbox from '../checkbox/Checkbox';
import { FILTER_GROUP_PLAYER, FILTER_GROUP_TEAM } from '../../store/modules/clip-filters';

export default {
	name:       'TeamFiltersSection',
	components: { Checkbox, FiltersListSection },
	props:      {
	  	clipFilters: {
	    	type:     Array,
			required: true,
		},
		title: {
	    	type:     String,
			required: true,
		},
		team: {
	    	type:     Object,
			required: true,
		},
		value: {
	    	type: Array,
		},
	},
	computed: {
		playerFilters() {
		  	return this.clipFilters
				.filter(
					(clipFilter) =>
						clipFilter.type === FILTER_GROUP_PLAYER
				)
				.sort((a, b) => {
				  if (a.count === 0 && b.count === 0) {
				    return 0;
					}

				 	if (b.count === 0) {
				 	  return -1;
					}

				 	if (a.count === 0) {
				 	  return 1;
					}

				 	return a.count > b.count ? -1 : 1;
				});
		},
		teamFilters() {
		  	return this.clipFilters
				.filter((clipFilter) => clipFilter.type === FILTER_GROUP_TEAM);
		},
		selectedPlayerFilters() {
		  	return this.value
				.filter((clipFilter) => clipFilter.type === FILTER_GROUP_PLAYER);
		},
		eligiblePlayerFilters() {
			return this.playerFilters.filter(clipFilter => clipFilter.count > 0);
		},
		canSelectTeam() {
			return this.teamFilters.length && this.teamFilters[0].count > 0;
		},
		isTeamSelected() {
			return !!this.value.find(f => f.type === FILTER_GROUP_TEAM);
		},
	},
	methods: {
		handleFiltersChange(selectedFilters) {
			this.$emit('input', this.team, selectedFilters);
		},
		handleSelectTeam(val) {
			if (val) {
				this.handleFiltersChange([...this.teamFilters, ...this.eligiblePlayerFilters]);
			} else {
				this.handleFiltersChange([]);
			}
		},
		handleSelectPlayers(playerFilters) {
			const selectedFilters = [];
			if (this.isTeamSelected) {
				selectedFilters.push(...this.teamFilters);
			}
			selectedFilters.push(...playerFilters);
			this.handleFiltersChange(selectedFilters);
		},
	},
};
</script>

<style lang="scss" scoped>

.subheader {
	margin-bottom: 16px;
}
</style>
